import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { APIService } from './../api.service';
import * as xlsx from 'xlsx';
import { CommonService } from '../services/common.service';
import { Router } from '@angular/router';
import { areAllEquivalent } from '@angular/compiler/src/output/output_ast';
import { NgxSpinnerService } from 'ngx-spinner';
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
  selector: 'app-trial-balance',
  templateUrl: './trial-balance.component.html',
  styleUrls: ['./trial-balance.component.scss']
})
export class TrialBalanceComponent implements OnInit {
  //#region "Declaration"
  jarvisData: any = [];
  finalArray: any = [];
  financialYears: any = [];
  param: any = {
    fromDT: new Date(),
    toDT: new Date()
  }
  LedgerRecord: any = [];
  HeadRecord: any = [];
  AccurateProfitOrLoss: any = [];
  openingStock: number = 0;
  openingPandL: any = [];
  BindTrialBlanaceArr: any = [];
  ExpenseArray: any = [];
  IncomeArray: any = [];
  agencyData: any = [];
  GrandTotal: any = {
    opngTotal: 0,
    crAmtTotal: 0,
    dbAmtTotal: 0,
    cloTotal: 0
  }

  Date1 = new Date();
  Year: any = ""
  IsPrevios = 0;
  accountStartDT: any;
  year: any;
  month: any;
  fromMinDate: any;

  acctStartDT: any;
  selectedFY: any;
  ERP_Agn: any = [];
  isAdmin: boolean = false;
  userList: Array<any> = [];
  ownUserRights: Array<any> = [];
  usersAllAcctRights: boolean = false;

  isWeb: boolean = true;
  show: any = {
    edit: true,
    save: false,
    querySubHead: true,
  };
  disable: any = {
    fromInput: true,
    toInput: true
  };
  isMobileView: boolean = this.deviceService.isMobile();

  @ViewChild('epltable', { static: false }) epltable!: ElementRef;

  exportToExcel: any = [];

  //export to excel
  tableToExcel = (function () {
    var uri = 'data:application/vnd.ms-excel;base64,'
        , template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body>{table}</body></html>'
        , base64 = function (s:any) { return window.btoa(unescape(encodeURIComponent(s))) }
        , format = function (s:any, c:any) { return s.replace(/{(\w+)}/g, function (m:any, p:any) { return c[p]; }) }

    return function (table: any, name : string, fileName:any) {
        if (!table.nodeType) table = table
        var ctx = { worksheet: name || 'Worksheet', table: table }
        //window.location.href = uri + base64(format(template, ctx))
        var link = document.createElement("a");
        link.download = fileName || 'download.xls';
        link.href = uri + base64(format(template, ctx));
        link.click();
    }
  })()

  //#endregion

  //#region "Function"

  constructor(private apiService: APIService, private commonService: CommonService, private router: Router, private SpinnerService: NgxSpinnerService, private deviceService: DeviceDetectorService) { }

  ngOnInit(): void {

    this.isWeb = this.apiService.apiCheckWeb();
    
    let agencyData = this.apiService.getCookie("M");
    if (agencyData) {
      this.agencyData = JSON.parse(agencyData);
    }
    let jarvis = this.apiService.getCookie("Jarvis");
    if (jarvis) {
      this.jarvisData = JSON.parse(jarvis);
    };
    
    let userList = this.apiService.getCookie('J');
    if (userList) {
      this.userList = JSON.parse(userList);
    }

    if(this.userList.length > 0){
      let myUserData: Array<any> = this.userList.filter((x: any) => x.UserID == this.jarvisData[0].UserID);
      if(myUserData.length > 0){
        this.ownUserRights = myUserData;
        if(this.ownUserRights[0].AcctsVchrEntry == true && this.ownUserRights[0].AcctsCfg == true && this.ownUserRights[0].Accts == true){
            this.usersAllAcctRights = true;
        }
      }
    }

    if (this.agencyData.length > 0 && this.jarvisData.length > 0) {
        this.isAdmin = (this.agencyData[0].AdminUserID == this.jarvisData[0].UserID) ? true : false;
    }
    let tmpERP_Agn = this.apiService.getCookie("ERP_Agn");
    if (tmpERP_Agn) {
      this.ERP_Agn = JSON.parse(tmpERP_Agn);
    }
    //Get Account Start DT
    if (this.ERP_Agn.length > 0) {
      this.acctStartDT = new Date(this.ERP_Agn[0].AccountStartDT);
    }

    this.financialYears = this.commonService.checkFinancialYear(this.acctStartDT, new Date());
    this.selectedFY = this.financialYears[this.financialYears.length - 1].FY;

    //this.getTrialBalance();


    if (this.Date1.getMonth() < 3) {
      this.Year = this.Date1.getFullYear() - 1
      this.IsPrevios = 1;
    } else {
      this.Year = this.Date1.getFullYear() + 1
      this.IsPrevios = 0;
    }

    if ($('#hdnAccountStartDT').val() != "") {
      this.accountStartDT = new Date(this.acctStartDT).customFormat("#DD#-#MMM#-#YYYY#");
      this.fromMinDate = new Date(this.acctStartDT).customFormat("#DD#-#MMM#-#YYYY#");
    }
    else {
      var year1 = new Date().getFullYear();
      this.accountStartDT = new Date(year1 + "/04/01").customFormat("#DD#-#MMM#-#YYYY#");
      this.fromMinDate = new Date(year1 + "/04/01").customFormat("#DD#-#MMM#-#YYYY#");
    }

    this.year = new Date(this.fromMinDate).getFullYear();
    this.month = new Date(this.fromMinDate).getMonth();

    if (this.month < 3) {
      this.year = this.year - 1;
    }
    this.fromMinDate = new Date(this.year + "/04/01").customFormat("#DD#-#MMM#-#YYYY#");

    //this.getProfitAndLoss();
    let currentDate = new Date();
    this.fn_Set_FinancialYear(currentDate);
  }

  fn_Set_FinancialYear(ToDT: any) {
    var Date1 = new Date(ToDT);
    var Year;
    var IsPrevios = 0;
    if (Date1.getMonth() < 3) {
      Year = Date1.getFullYear() - 1
      IsPrevios = 1;
    } else {
      Year = Date1.getFullYear() + 1
      IsPrevios = 0;
    }
    if (IsPrevios == 1) {
      this.param.fromDT = new Date(Year + "/04/01");
      this.param.toDT = new Date(Date1.getFullYear() + "/03/31");
    }
    else if (IsPrevios == 0) {
      this.param.fromDT = new Date(Date1.getFullYear() + "/04/01");
      this.param.toDT = new Date(Year + "/03/31");
    }

    this.HeadRecord = [];
    this.ExpenseArray = [];
    this.IncomeArray = [];
    this.finalArray = [];

    this.getTrialBalance();
  }

  ddlchangeYear() {
    if (this.selectedFY != 'Other') {
      let selectedYear;
      selectedYear = this.selectedFY.split("-")[0] + "";
      let toDate = (Number(selectedYear) + 1) + "/03/31";
      this.fn_Set_FinancialYear(toDate);
    }
  }

  fn_ChangeDate() {
    // Here Set Accounting Year of Selected Date
    if (new Date(this.param.fromDT) > new Date(this.fromMinDate) && new Date(this.param.fromDT) < new Date(this.acctStartDT)) {
      alert("Please select date either " + this.fromMinDate + " or date after " + this.acctStartDT + ".");
      if (this.IsPrevios == 1) {
        this.param.fromDT = new Date(this.Year + "/04/01");
        this.param.toDT = new Date(this.Date1.getFullYear() + "/03/31");
      }
      else if (this.IsPrevios == 0) {
        this.param.fromDT = new Date(this.Date1.getFullYear() + "/04/01");
        this.param.ToDT = new Date(this.Year + "/03/31");
      }
      return;
    }


    // var Date1 = new Date(this.param.toDT);
    // var acctStartDT = new Date(this.acctStartDT);
    // let CurrentDate = new Date();

    // if (Date1 < acctStartDT) {
    //     alert("Please select date after " + this.acctStartDT);
    //     this.fn_Set_FinancialYear(CurrentDate);
    //     return;
    // }

    //fn_HeadSummary();


    //fn_Set_FinancialYear($scope.ToDate);
    this.HeadRecord = [];
    this.ExpenseArray = [];
    this.IncomeArray = [];
    this.finalArray = [];

    this.getTrialBalance();

  }

  getTrialBalance() {
    let data = [{
      fromDT: new Date(this.param.fromDT).customFormat("#DD#-#MMM#-#YY#"),
      toDT: new Date(this.param.toDT).customFormat("#DD#-#MMM#-#YY#")
    }];

    let myParams = [{
      myUserID: this.jarvisData[0].UserID,
      myToken: this.jarvisData[0].WebToken,
      forAgencyID: this.jarvisData[0].AgencyIDs,
      myAgencyIDs: this.jarvisData[0].AgencyIDs,
      myLastSyncDT: null,
      isWeb: true,
      ForERPAgencyID: this.agencyData[0].ERPAgencyID,
      actionType: 'get',
      moduleID: 1,
      data: JSON.stringify(data)
    }];

    this.apiService.getData(myParams, this.successResp.bind(this), this.failureResp.bind(this));
  }

  //failureResp - failure handler
  failureResp(res: any) {
    if (res.error) {
    }
    else {
      alert(res.message);
    }
  }

  //successResp - success  get handler
  successResp(res: any) {
    
    if (res.error) {
    }
    else {
      if (res) {
        var reponseData = JSON.parse(res.updatePackage);
        this.LedgerRecord = reponseData.Table1;
        this.HeadRecord = reponseData.Table2;
        this.AccurateProfitOrLoss = reponseData.Table3;
        this.openingStock = this.AccurateProfitOrLoss[0].OpeningStock;
        if (reponseData.Table4) {
          this.openingPandL = reponseData.Table4[0].OpeningProfitLoss;
        }
        else {
          this.openingPandL = 0;
        }

        // this.bindHeadLedgerTohierarchical();
        this.sortHeads();

        for (let i = 0; i < this.HeadRecord.length; i++) {
          if (this.HeadRecord[i].ParentHeadID == 0 && this.HeadRecord[i].LedgerType == 4) {
            this.ExpenseArray.push({
              HeadID: this.HeadRecord[i].HeadID,
              HeadName: this.HeadRecord[i].HeadName,
              CloBal: this.HeadRecord[i].CloBal,
              LedgerID: 0
            });
          };
        }

        for (let i = 0; i < this.HeadRecord.length; i++) {
          if (this.HeadRecord[i].ParentHeadID == 0 && this.HeadRecord[i].LedgerType == 3) {
            this.IncomeArray.push({
              HeadID: this.HeadRecord[i].HeadID,
              HeadName: this.HeadRecord[i].HeadName,
              CloBal: this.HeadRecord[i].CloBal,
              LedgerID: 0
            });
          };
        }

        // this.BindTrialBlanaceArr.forEach((i: any) => {
        //   if(i.ParentHeadID == 0){
        //     this.finalArray.push({
        //       HeadID:  i.HeadID,
        //       HeadName: i.HeadName,
        //       OpBal: String(i.OpBal).replace(/\,/g, ""),
        //       CrAmt: String(i.CrAmt).replace(/\,/g, ""),
        //       DbAmt: String(i.DbAmt).replace(/\,/g, ""),
        //       CloBal: String(i.CloBal).replace(/\,/g, ""),
        //       level: i.countLevel,
        //       ledgerID: 0
        //     });
        //     if(i.children){
        //       if(i.children.length > 0){
        //         this.getNlevelRecorsion(i.children, 1);
        //       }
        //     }
        //   }
        // });
        
        this.HeadRecord.forEach((i: any) => {            
            this.finalArray.push({
              HeadID:  i.HeadID,
              HeadName: i.HeadName,
              OpBal: String(i.OpBal).replace(/\,/g, ""),
              CrAmt: String(i.CrAmt).replace(/\,/g, ""),
              DbAmt: String(i.DbAmt).replace(/\,/g, ""),
              CloBal: String(i.CloBal).replace(/\,/g, ""),
              level: i.countLevel,
              ledgerID: 0,
              levelPath: i.LevelPath
            });

              let isLedgers: Array<any> = this.LedgerRecord.filter((x: any) => x.LevelPath == i.LevelPath);
              if(isLedgers.length > 0){
                isLedgers.forEach((e: any) => {
                  this.finalArray.push({
                    HeadID:  e.HeadID,
                    HeadName: e.LedgerName,
                    OpBal: String(e.OpBal).replace(/\,/g, ""),
                    CrAmt: String(e.CrAmt).replace(/\,/g, ""),
                    DbAmt: String(e.DbAmt).replace(/\,/g, ""),
                    CloBal: String(e.CloBal).replace(/\,/g, ""),
                    level: (i.countLevel + 1),
                    ledgerID: e.LedgerID,
                    levelPath: i.LevelPath + 'Z~'
                  });
                });                
              }
        });
        
        this.finalArray = this.finalArray.sort((a : any,b : any) => a.levelPath.localeCompare(b.levelPath, 'en', { numeric: true }))
        this.GrandTotal = {
          opngTotal: 0,
          crAmtTotal: 0,
          dbAmtTotal: 0,
          cloTotal: 0
        };
        for (var i = 0; i < this.finalArray.length; i++) {
          if (this.finalArray[i].level == 0) {
            this.GrandTotal.opngTotal = this.GrandTotal.opngTotal + Number(String(this.finalArray[i].OpBal).replace(/\,/g, ""));
            this.GrandTotal.crAmtTotal = this.GrandTotal.crAmtTotal + Number(String(this.finalArray[i].CrAmt).replace(/\,/g, ""));
            this.GrandTotal.dbAmtTotal = this.GrandTotal.dbAmtTotal + Number(String(this.finalArray[i].DbAmt).replace(/\,/g, ""));
            this.GrandTotal.cloTotal = this.GrandTotal.cloTotal + Number(String(this.finalArray[i].CloBal).replace(/\,/g, ""));
          }
        }
        this.exportToExcel = this.finalArray;
      }
    }
  }

 sortHeads(){
    this.HeadRecord = this.HeadRecord.sort((a : any,b : any) => a.LevelPath.localeCompare(b.LevelPath, 'en', { numeric: true }))

    //level path count of head record.....
    this.HeadRecord.forEach((p: any) => {
      if (p.LevelPath) {
        let count = (p.LevelPath.match(/~/g) || []).length;
          p.countLevel = count - 3;
      }
    });
 }

  bindHeadLedgerTohierarchical() {
    this.BindTrialBlanaceArr = [];
    let products: any = [];
    let HeadRcrd: any = [];
    let LedgerRcrd: any = [];

    HeadRcrd = this.HeadRecord;
    LedgerRcrd = this.LedgerRecord;

    // HeadRcrd.sort(function (a: any, b: any) {
    //   if (a.HeadID < b.HeadID) //sort string ascending
    //     return -1
    //   if (a.HeadID > b.HeadID)
    //     return 1
    //   return 0 //default return value (no sorting)
    // });

    for (let i = 0; i < HeadRcrd.length; i++) {
      if (HeadRcrd[i].ParentHeadID == 0 && !(HeadRcrd[i].ParentHeadID.toString() in this.BindTrialBlanaceArr)) {
        HeadRcrd[i].children = [];
        products.push(HeadRcrd[i]);
        this.BindTrialBlanaceArr[HeadRcrd[i].HeadID.toString()] = HeadRcrd[i];
      }
    }

    // for(let i = 0; i < HeadRcrd.length; i++ ) {
    //   if (HeadRcrd[i].ParentHeadID > 0) {
    //     if(!HeadRcrd[i].children) {
    //       HeadRcrd[i].children = [];
    //     }
    //     for(let o = 0; o < this.BindTrialBlanaceArr.length; o++){
    //       if(this.BindTrialBlanaceArr[o]) {
    //         if(this.BindTrialBlanaceArr[o].HeadID == HeadRcrd[i].ParentHeadID) {
    //           this.BindTrialBlanaceArr[o].children.push(HeadRcrd[i]);
    //           let tmpChildrean = this.BindTrialBlanaceArr[o].children;
    //           while(tmpChildrean.length > 0) {
    //             for(let p = 0; p < tmpChildrean.length; p++) {
    //               //if(!tmpChildrean[p].LedgerID){
    //                 for(let c = 0; c < HeadRcrd.length; c++) {
    //                   if(tmpChildrean[p].HeadID == HeadRcrd[c].ParentHeadID){
    //                     if(!tmpChildrean[p].children) {
    //                       tmpChildrean[p].children = [];
    //                     }
    //                     tmpChildrean[p].children.push(HeadRcrd[c]);
    //                     tmpChildrean = tmpChildrean[p].children;
    //                   }
    //                 }
    //               //}                  
    //             }
    //             break;
    //           }
    //         }
    //       }
    //     }
    //     if (this.BindTrialBlanaceArr[HeadRcrd[i].HeadID.toString()]) {
    //         this.BindTrialBlanaceArr[HeadRcrd[i].HeadID.toString()] = HeadRcrd[i];
    //   } 
    // }

    // }
    //  console.log('this.BindTrialBlanaceArr', this.BindTrialBlanaceArr);

    for (let i = 0; i < HeadRcrd.length; i++) {
      if (HeadRcrd[i].ParentHeadID > 0) {
        HeadRcrd[i].children = [];
        if (this.BindTrialBlanaceArr[HeadRcrd[i].ParentHeadID.toString()]) {
          this.BindTrialBlanaceArr[HeadRcrd[i].ParentHeadID.toString()].children.push(HeadRcrd[i]);
        }

        if (this.BindTrialBlanaceArr[HeadRcrd[i].HeadID.toString()]) {
          this.BindTrialBlanaceArr[HeadRcrd[i].HeadID.toString()] = HeadRcrd[i];
        }
      }
    }

    // Get Ledger.....
    for (let i = 0; i < LedgerRcrd.length; i++) {
      if (LedgerRcrd[i].LedgerName != "Profit & Loss A/c") {
        if (this.BindTrialBlanaceArr[LedgerRcrd[i].HeadID.toString()]) {
          this.BindTrialBlanaceArr[LedgerRcrd[i].HeadID.toString()].children.push(LedgerRcrd[i]);
        }
      }
    }

    // for(let i = 0; i < LedgerRcrd.length; i++ ) {
    //   if (LedgerRcrd[i].LedgerName != "Profit & Loss A/c") {
    //     // if (this.BindTrialBlanaceArr[LedgerRcrd[i].HeadID.toString()]) {
    //     //     this.BindTrialBlanaceArr[LedgerRcrd[i].HeadID.toString()].children.push(LedgerRcrd[i]);
    //     // }

    //     for(let o = 0; o < this.BindTrialBlanaceArr.length; o++){
    //       if(this.BindTrialBlanaceArr[o]) {
    //         if(this.BindTrialBlanaceArr[o].HeadID == LedgerRcrd[i].HeadID) {
    //           this.BindTrialBlanaceArr[o].children.push(LedgerRcrd[i]);
    //           let tmpChildrean = this.BindTrialBlanaceArr[o].children;
    //           while(tmpChildrean.length > 0) {
    //             for(let p = 0; p < tmpChildrean.length; p++) {
    //               if(tmpChildrean[p].LedgerID){
    //                 for(let c = 0; c < LedgerRcrd.length; c++){
    //                   if(tmpChildrean[p].HeadID == LedgerRcrd[c].HeadID){
    //                     if(!tmpChildrean[p].LedgerID) {
    //                       if(!tmpChildrean[p].children) {
    //                         tmpChildrean[p].children = [];
    //                       }
    //                       let tmp = tmpChildrean[p].children.filter((x: any) => x.LedgerID == LedgerRcrd[c].LedgerID);
    //                       if(tmp.length == 0){
    //                         tmpChildrean[p].children.push(LedgerRcrd[c]);
    //                         tmpChildrean = tmpChildrean[p].children;
    //                       }
    //                     }
    //                   }
    //                 }
    //               }
    //             }
    //             break;
    //           }
    //         }
    //       }

    //     }
    //   }
    // }

    //Solution for opening stock -- Pankil
    var openingObj = {
      BudgetAmt: "0.00",
      CloBal: '0.00',
      CrAmt: "0.00",
      DbAmt: this.openingStock,
      HeadID: 0,
      HeadName: "Opening Stock",
      LedgerType: 0,
      LevelPath: "",
      OpBal: this.openingStock,
      ParentHeadID: 0,
      children: []
    }

    this.BindTrialBlanaceArr[0] = openingObj;

    var pAndLObj = {
      BudgetAmt: "0.00",
      CloBal: this.openingPandL,
      CrAmt: this.openingPandL < 0 ? this.openingPandL : '0.00',
      DbAmt: this.openingPandL > 0 ? this.openingPandL : '0.00',
      HeadID: 0,
      HeadName: "Profit & Loss A/c",
      LedgerType: 0,
      LevelPath: "",
      OpBal: "0.00",
      ParentHeadID: 0,
      children: []
    }
    this.BindTrialBlanaceArr['-1'] = pAndLObj;

  }

  getNlevelRecorsion(array: any, level: any) {
    var newLevel = level;
    for (let i = 0; i < array.length; i++) {
      this.finalArray.push({
        HeadID: array[i].HeadID,
        HeadName: array[i].HeadName ? array[i].HeadName : array[i].LedgerName,
        OpBal: String(array[i].OpBal).replace(/\,/g, ""),
        CrAmt: String(array[i].CrAmt).replace(/\,/g, ""),
        DbAmt: String(array[i].DbAmt).replace(/\,/g, ""),
        CloBal: String(array[i].CloBal).replace(/\,/g, ""),
        level: array[i].countLevel,
        ledgerID: array[i].HeadName ? 0 : array[i].LedgerID
      });
      this.exportToExcel = this.finalArray;
      if (array[i].children) {

        if (array[i].children.length > 0) {
          this.getNlevelRecorsion(array[i].children, newLevel + 1);
        }
      }
    };
  }

  backBtn() {
    this.router.navigate(['/accounts']);
  }

// Sorting By Alpha Numerical Head PathLevel.....

// alphaNumSort() - Sort array alphanumerically.
 alphaNumSort(name: any) {
  var reA = /[^a-zA-Z]/g; // Remove non-alphabets
  var reN = /[^0-9]/g;    // Remove non-numbers
  var reNStart = /[^0-9]/;
  return function (a: any, b: any) {

      var aStr = a[name].toLowerCase();
      var bStr = b[name].toLowerCase();

      //var aANumStart = aStr.match(reNStart).length > 0;
      //console.log(aANumStart);

      var aAName = aStr.replace(reA, "");
      var aBName = bStr.replace(reA, "");
      if (aAName === aBName) {
          var aANum = parseInt(a[name].replace(reN, ""), 10); // 10 is for decimal
          var aBNum = parseInt(b[name].replace(reN, ""), 10);
          return aANum === aBNum ? 0 : aANum > aBNum ? 1 : -1;
      }
      else {
          return aAName > aBName ? 1 : -1;
      }
  }

}

// dlNaturalSort() - Sorting
dlNaturalSort(myList : any, columnName : any) {

  var arrayStartNum = [];
  var arrayNotStartNum = [];

  // First parse the list and classify between ones that start with number and ones that don't.
  for (var i = 0; i < myList.length; i++) {

      if (myList[i][columnName].match(/^[0-9].*$/) == null) {
          arrayNotStartNum.push(myList[i]);
      } else {
          arrayStartNum.push(myList[i]);
      }
  }

  // Sort both arrays independently.
  arrayStartNum.sort(this.alphaNumSort(columnName));
  arrayNotStartNum.sort(this.alphaNumSort(columnName));

  // Concat the arrays and return.
  return arrayStartNum.concat(arrayNotStartNum);
}

// open ledger in trial balancesheet to direct account.....
  fn_openHeadLedger(headID: any, ledgerID: any, fromDT: any, toDT: any) {
    let urlCheck: string = "";
    if(this.apiService.fn_isLiveURL() == true){
      urlCheck = "/ERP"
    }
    if (ledgerID == 0) {
      urlCheck += "/accounts;id=" + headID + ";h=1" + ";fdt=" + new Date(fromDT).customFormat("#DD#-#MMM#-#YY#") + ";tdt=" + new Date(toDT).customFormat("#DD#-#MMM#-#YY#");
    }
    else {
      urlCheck += "/accounts;id=" + ledgerID + ";h=0" + ";fdt=" + new Date(fromDT).customFormat("#DD#-#MMM#-#YY#") + ";tdt=" + new Date(toDT).customFormat("#DD#-#MMM#-#YY#");
    }
    // Using App
    let target: string = "_blank";
    if(this.isWeb == false){
      target = "_self";
    }
    window.open(urlCheck, target);
  }

  // export to excel.....
  exportToExcelActivities() {
    var html = "";
    // Title
    html += "<table><tr>";
    html += "<th style='text-align: left;'>Trial Balance</th>"
    html += "</table></tr>"; 
  
    html += "<table><tr></table></tr>";
    html += "<table><tr>";
    let date: any = new Date(this.param.fromDT).customFormat("#DD#-#MMM#-#YYYY#") + " to " + new Date(this.param.toDT).customFormat("#DD#-#MMM#-#YYYY#");
    html += "<p><b>Period : </b>"+ (this.selectedFY != 'Other' ?  this.selectedFY  : date) + "</p>"
    html += "</table></tr>";
  
    html += "<table><tr>";
    var strHeader = ""
    strHeader += "<th style='text-align: left;'>Head / Ledger</th>";
    strHeader += "<th style='text-align: right;'>Opening</th>";
    strHeader += "<th style='text-align: right;'>Debit</th>";
    strHeader += "<th style='text-align: right;'>Credit</th>";
    strHeader += "<th style='text-align: right;'>Closing</th>";
  
    strHeader += "</tr>"
    html += strHeader;
    var body = "";
    this.exportToExcel.forEach((item:any, key:any) => {
      body += "<tr>";
      body += "<td style='text-align: left;'>" + item.HeadName + "</td>";
      var newBal = ''
      if(item.OpBal < 0){
        newBal = 'Cr'
      }
      else{
        newBal = 'Db'
      }

      item.OpBal = String(Number(item.OpBal).toFixed(2).replace(/(\d)(?=(\d{2})+\d\.)/g, '$1,'),).replace("-", "")
      body += "<td style='text-align: right;'>" + item.OpBal + " " + newBal +"</td>";   
      item.DbAmt = String(Number(item.DbAmt).toFixed(2).replace(/(\d)(?=(\d{2})+\d\.)/g, '$1,'))
      body += "<td style='text-align: right; mso-number-format: \"#,##0.00\"'>" + item.DbAmt + "</td>";
      item.CrAmt = Number(item.CrAmt).toFixed(2).replace(/(\d)(?=(\d{2})+\d\.)/g, '$1,')
      body += "<td style='text-align: right; mso-number-format: \"#,##0.00\"'>" +  item.CrAmt + "</td>";
      var CloBaltemp = item.CloBal < 0 ? 'Cr' : 'Db';
      item.CloBal = String(Number(item.CloBal).toFixed(2).replace(/(\d)(?=(\d{2})+\d\.)/g, '$1,'),).replace("-", "") 
      body += "<td style='text-align: right;'>" +  item.CloBal + " " + CloBaltemp + "</td>";
    body += "</tr>";
    })

    body += "<tr>";
    body += "<td style='text-align: left; font-weight:bold'>" + 'Grand Total' +"</td>";  
    var opngTotalTemp = this.GrandTotal.opngTotal < 0 ? 'Cr' : 'Db';
    var opngTotal = String(Number(this.GrandTotal.opngTotal).toFixed(2).replace(/(\d)(?=(\d{2})+\d\.)/g, '$1,'),).replace("-", "")   
    body += "<td style='text-align: right; font-weight:bold;'>" + opngTotal + " " + opngTotalTemp + "</td>";
    body += "<td style='text-align: right; font-weight:bold; mso-number-format: \"#,##0.00\"'>" +  this.GrandTotal.dbAmtTotal + "</td>"; 
    body += "<td style='text-align: right; font-weight:bold; mso-number-format: \"#,##0.00\"'>" + this. GrandTotal.crAmtTotal + "</td>";
    var GrandTotaltemp = this.GrandTotal.cloTotal < 0 ? 'Cr' : 'Db';
    var cloTotal = String(Number(this.GrandTotal.cloTotal).toFixed(2).replace(/(\d)(?=(\d{2})+\d\.)/g, '$1,'),).replace("-", "") 
    body += "<td style='text-align: right; font-weight:bold;'>" +  cloTotal + " " + GrandTotaltemp + "</td>";
    body += "</tr>";

    html += body;
    html += "</table>";
    this.tableToExcel(html, 'Sheet1', 'Trial Balance');
  }
  
  editPeriod() {
    this.show.edit = false;
    this.show.save = true;
    this.disable.fromInput = false;
    this.disable.toInput = false;
  }

  changePeriod() {
    this.fn_ChangeDate();
    this.show.edit = true;
    this.show.save = false;
    this.disable.fromInput = true;
    this.disable.toInput = true;
  }

  expandView(head: any) {
    if(this.isMobileView){
      this.fn_openHeadLedger(head.HeadID, head.ledgerID, this.param.fromDT, this.param.toDT)
      return;
    }

    let target: string = "_blank";
    let isLive = this.apiService.fn_isLiveURL();
    let fromDT = new Date(this.param.fromDT).customFormat("#DD#-#MMM#-#YYYY#");
    let toDT = new Date(this.param.toDT).customFormat("#DD#-#MMM#-#YYYY#");
    if(this.isWeb == false) {
      target = "_self";
    }

    if(head.ledgerID == '0') {
      let headID = head.HeadID;
      window.open((isLive ? '/ERP' : '') + '/HeadRecord?hid=' + encodeURIComponent(headID) + '&fromDT=' + encodeURIComponent(fromDT) + '&toDT=' + encodeURIComponent(toDT), target);
    } else {
      let ledgerID = head.ledgerID;
      window.open((isLive ? '/ERP' : '') + '/LedgerRecord?lid=' + encodeURIComponent(ledgerID) + '&fromDT=' + encodeURIComponent(fromDT) + '&toDT=' + encodeURIComponent(toDT), target);
    }
  }
  //#endregion

}



declare global {
  interface Date {
    customFormat(formatString: any): string;
  }
}


// String Prototye
Date.prototype.customFormat = function (formatString: any) {
  var YYYY, YY, MMMM, MMM, MM, M, DDDD, DDD, DD, D, hhhh, hhh, hh, h, mm, m, ss, s, ampm, AMPM, dMod, th;
  YY = ((YYYY = this.getFullYear()) + "").slice(-2);
  MM = (M = this.getMonth() + 1) < 10 ? ('0' + M) : M;
  MMM = (MMMM = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"][M - 1]).substring(0, 3);
  DD = (D = this.getDate()) < 10 ? ('0' + D) : D;
  DDD = (DDDD = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"][this.getDay()]).substring(0, 3);
  th = (D >= 10 && D <= 20) ? 'th' : ((dMod = D % 10) == 1) ? 'st' : (dMod == 2) ? 'nd' : (dMod == 3) ? 'rd' : 'th';
  formatString = formatString.replace("#YYYY#", YYYY).replace("#YY#", YY).replace("#MMMM#", MMMM).replace("#MMM#", MMM).replace("#MM#", MM).replace("#M#", M).replace("#DDDD#", DDDD).replace("#DDD#", DDD).replace("#DD#", DD).replace("#D#", D).replace("#th#", th);
  h = (hhh = this.getHours());
  if (h == 0) h = 24;
  if (h > 12) h -= 12;
  hh = h < 10 ? ('0' + h) : h;
  hhhh = h < 10 ? ('0' + hhh) : hhh;
  AMPM = (ampm = hhh < 12 ? 'am' : 'pm').toUpperCase();
  mm = (m = this.getMinutes()) < 10 ? ('0' + m) : m;
  ss = (s = this.getSeconds()) < 10 ? ('0' + s) : s;
  return formatString.replace("#hhhh#", hhhh).replace("#hhh#", hhh).replace("#hh#", hh).replace("#h#", h).replace("#mm#", mm).replace("#m#", m).replace("#ss#", ss).replace("#s#", s).replace("#ampm#", ampm).replace("#AMPM#", AMPM);
}


